import React from 'react';
import styled from 'styled-components';
import {
  brandColours,
  maxBreakpointQuery,
  minBreakpointQuery,
  sectionMargins,
  sectionPaddings,
} from '../styles';
import { Container, Heading, HtmlContent } from './ui';
import FeaturedStep from './FeaturedStep';

const StyledFeaturedSteps = styled.section`
  ${sectionMargins()};
`;

const StyledContainer = styled(Container)`
  ${maxBreakpointQuery.tiny`
    padding-left: 0;
    padding-right: 0;
  `}
`;

const StyledInner = styled.div`
  ${sectionPaddings()};
  background-color: ${brandColours.primary};
  border-radius: 50px;
`;

const StyledHeader = styled.header`
  margin: 0 auto 60px;
  max-width: 860px;
  text-align: center;

  ${minBreakpointQuery.small`
    margin-bottom: 80px;
  `}

  ${minBreakpointQuery.large`
    margin-bottom: 100px;
  `}
`;

const StyledText = styled(HtmlContent)`
  margin-top: 20px;
`;

const StyledItems = styled.ol`
  counter-reset: steps-counter;
  display: grid;
  gap: 50px;
`;

const FeaturedSteps = ({ heading, text, items }) => (
  <StyledFeaturedSteps>
    <StyledContainer wider={true}>
      <StyledInner>
        <Container>
          <StyledHeader>
            <Heading>{heading}</Heading>
            <StyledText content={text} />
          </StyledHeader>
          <StyledItems>
            {items.map(({ image, heading, content, link }, id) => (
              <FeaturedStep
                key={id}
                image={image}
                heading={heading}
                content={content}
                link={link}
              />
            ))}
          </StyledItems>
        </Container>
      </StyledInner>
    </StyledContainer>
  </StyledFeaturedSteps>
);

export default FeaturedSteps;
